<template>
<div>
  <div class="main-content">
    <div class="content-block box withdrawal-area">
      <h1>退会規約</h1>
      <p> 一度退会されますと、登録した全ユーザのメールアドレス等のデータは全て消去されます。<br>
      また、当サイト利用に伴って登録したデータ等は退会によって消滅することにあらかじめ同意するものとします。</p>
      <button class="pure-button" @click="withdrawal">規約に同意して退会する</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  methods: {
    withdrawal() {
      this.$http.post("/withdrawal").then(() => {
        this.$store.dispatch("logout").then(() => {
          this.$router.push({ name: "finish_withdrawal" })
        })
      }).catch(() => {
        alert("退会処理に失敗しました。")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.withdrawal-area {
  text-align: center;
  margin: 16px auto;

  button {
    margin-top: 16px;
    background: linear-gradient(180deg, #fff5ee, #83ccd2);
    color: black;
  }
}

@media screen and (max-width: 420px) {
  .withdrawal-area {
    p {
      margin: auto 10px;
    }
  }
}
</style>